import React from "react"
import { ListItem, List } from "@chakra-ui/react"
import PackageIcon from "./PackageIcon"

export default function PackageList({ list }) {
  return (
    <List mx="auto" mb={12} spacing={6}>
      {list.map((node, index) => {
        return (
          <ListItem key={index} display="flex" alignItems="center">
            <PackageIcon />
            {node}
          </ListItem>
        )
      })}
    </List>
  )
}
